module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Bold.166b728.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Bold.ttf
// module id = yQp7
// module chunks = 1